import classnames from "classnames";
import React, { Component } from "react";
import ReactLoading from "react-loading";
import { connect } from "react-redux";
import {
  Col,
  Nav,
  NavItem,
  NavLink,
  Row
} from "reactstrap";
import onBoarding from "../../files/ic_on_boarding.png";
import SelectationTab from "./SelectationTab";
import OnBoardingList from "./OnBoardingList";
import getDeviceType from "../../helpers/getDeviceTypeHelper";
import {deviceType} from "../../constants/general.constant";
const _ = require("lodash");
class OnBoarding extends Component {
  constructor(props) {
    super(props);    
    this.state = {
      activeTab: "1",
      onDisplayAll: true,
      onDisplayRequestedRPM: false,
      onDisplayPreShipment: false,
      onNeedToShipDevice: false,
      onDisplayWelcomePhoneNeeded: false,
      onDisplayWelcomePhoneCompleted: false, 
      onDeviceProvidedNeedToShipDevice: false,
      loading: true,
      catagoryID: undefined
    };
  }
  
  componentDidMount() {
    this.props.dispatch({
      type: "DO_GET_ALL_DEVICE"
    });
    this.onFetchReadingCount();    
  }
  onFetchReadingCount(){
    this.props.dispatch({
      type: "DO_GET_ON_BOARDING_COUNT"
    });
  }

  onDisplayAll() {
    this.onFetchReadingCount();        
    this.setState({
      onDisplayAll: true,
      onDisplayRequestedRPM: false,
      onDisplayPreShipment: false,
      onNeedToShipDevice: false,
      onDisplayWelcomePhoneNeeded: false,
      onDisplayWelcomePhoneCompleted: false,
      catagoryID: undefined,
      onDeviceProvidedNeedToShipDevice: false,      
    }, () => {
      this.fetchData();
    });
  }

  onDisplayRequestedRPM() {
    this.onFetchReadingCount(); 
    this.setState({
      onDisplayAll: false,
      onDisplayRequestedRPM: true,
      onDisplayPreShipment: false,
      onDisplayWelcomePhoneNeeded: false,
      onDisplayWelcomePhoneCompleted: false,      
      catagoryID: "64620873b1cebb9c4d5b70ea",
      onDeviceProvidedNeedToShipDevice: false      
    }, () => {
      this.fetchData();
    });
  }

  onDisplayPreShipment() {
    this.onFetchReadingCount(); 
    this.setState({
      onDisplayAll: false,
      onDisplayRequestedRPM: false,
      onDisplayPreShipment: true,
      onNeedToShipDevice: false,
      onDisplayWelcomePhoneNeeded: false,
      onDisplayWelcomePhoneCompleted: false,     
      catagoryID: "646208d0b1cebb9c4d5b70eb",
      onDeviceProvidedNeedToShipDevice: false    
    }, () => {
      this.fetchData();
    });
  }
  onNeedToShipDevice() {
    this.onFetchReadingCount(); 
    this.setState({
      onDisplayAll: false,
      onDisplayRequestedRPM: false,
      onDisplayPreShipment: false,
      onNeedToShipDevice: true,
      onDisplayWelcomePhoneNeeded: false,
      onDisplayWelcomePhoneCompleted: false,      
      catagoryID: "64f02ecb6d9efff481a93e67",
      onDeviceProvidedNeedToShipDevice: false      
    }, () => {
      this.fetchData();
    });
  }
  onDeviceProvidedNeedToShipDevice(){
    this.onFetchReadingCount(); 
    this.setState({
      onDisplayAll: false,
      onDisplayRequestedRPM: false,
      onDisplayPreShipment: false,
      onNeedToShipDevice: false,
      onDisplayWelcomePhoneNeeded: false,
      onDisplayWelcomePhoneCompleted: false,
      onDeviceProvidedNeedToShipDevice: true,      
      catagoryID: "673b0d0295dac2bd8a709055"
    }, () => {
      this.fetchData();
    });
  }
  onDisplayWelcomePhoneNeeded() {
    this.onFetchReadingCount(); 
    this.setState({
      onDisplayAll: false,
      onDisplayRequestedRPM: false,
      onDisplayPreShipment: false,
      onNeedToShipDevice: false,
      onDisplayWelcomePhoneNeeded: true,
      onDisplayWelcomePhoneCompleted: false, 
      onDeviceProvidedNeedToShipDevice: false,     
      catagoryID: "646208d3b1cebb9c4d5b70ec"
    }, () => {
      this.fetchData();
    });
  }
  onDisplayWelcomePhoneCompleted() {
    this.onFetchReadingCount(); 
    this.setState({
      onDisplayAll: false,
      onDisplayRequestedRPM: false,
      onDisplayPreShipment: false,
      onNeedToShipDevice: false,
      onDisplayWelcomePhoneNeeded: false,
      onDisplayWelcomePhoneCompleted: true,
      onDeviceProvidedNeedToShipDevice: false,            
      catagoryID: "646208d6b1cebb9c4d5b70ed"
    }, () => {
      this.fetchData();
    });
  }

  render() {   
    var allOnBoarding = { backgroundColor: "#198ae3", color: "white" };     
    var mRequestedRPM = { backgroundColor: "white", color: "black" };
    var mPreShipment = { backgroundColor: "white", color: "black" };
    var mNeedToShipDevice = { backgroundColor: "white", color: "black" };
    var WelcomePhoneNeeded = { backgroundColor: "white", color: "black" };
    var WelcomePhoneCompleted = { backgroundColor: "white", color: "black" };
    var deviceProvidedNeedToShipDevice = { backgroundColor: "white", color: "black" };

    var allOnBoardingSize = this.props.onBoardingDataCount ? this.props.onBoardingDataCount.allOnBoarding : 0;
    var requestedRPMOrderFromProviderSize = this.props.onBoardingDataCount ? this.props.onBoardingDataCount.requestedRPMOrderFromProviderSize : 0;
    var preShipmentPhoneCallSize = this.props.onBoardingDataCount ? this.props.onBoardingDataCount.preShipmentPhoneCallSize : 0;
    var needToShipDeviceSize = this.props.onBoardingDataCount ? this.props.onBoardingDataCount.needToShipDeviceSize : 0;
    var welcomePhoneCallNeededSize = this.props.onBoardingDataCount ? this.props.onBoardingDataCount.welcomePhoneCallNeededSize : 0;
    var welcomePhoneCompleted = this.props.onBoardingDataCount ? this.props.onBoardingDataCount.welcomeCallCompletedSize : 0;
    var deviceProvidedNeedToShipDeviceSize = this.props.onBoardingDataCount ? this.props.onBoardingDataCount.deviceProvidedNeedToShipDeviceSize : 0;

    if (this.state.onDisplayRequestedRPM) {
      // Display Requested RPM
      allOnBoarding = { backgroundColor: "white", color: "black" };
      mRequestedRPM = { backgroundColor: "#198ae3", color: "white" };
      mPreShipment = { backgroundColor: "white", color: "black" };
      mNeedToShipDevice = { backgroundColor: "white", color: "black" };
      WelcomePhoneNeeded = { backgroundColor: "white", color: "black" };
      WelcomePhoneCompleted = { backgroundColor: "white", color: "black" };      
      deviceProvidedNeedToShipDevice =  { backgroundColor: "white", color: "black" };      
    } else if (this.state.onDisplayPreShipment) {
      // Display Pre Shipment
      allOnBoarding = { backgroundColor: "white", color: "black" };
      mRequestedRPM = { backgroundColor: "white", color: "black" };
      mPreShipment = { backgroundColor: "#198ae3", color: "white" };
      mNeedToShipDevice = { backgroundColor: "white", color: "black" };
      WelcomePhoneNeeded = { backgroundColor: "white", color: "black" };
      WelcomePhoneCompleted = { backgroundColor: "white", color: "black" };      
      deviceProvidedNeedToShipDevice =  { backgroundColor: "white", color: "black" };      
    } else if (this.state.onNeedToShipDevice) {
      // Display Requested RPM
      allOnBoarding = { backgroundColor: "white", color: "black" };
      allOnBoarding = { backgroundColor: "white", color: "black" };
      mRequestedRPM =  { backgroundColor: "white", color: "black" };
      mPreShipment = { backgroundColor: "white", color: "black" };
      mNeedToShipDevice = { backgroundColor: "#198ae3", color: "white" };
      WelcomePhoneNeeded = { backgroundColor: "white", color: "black" };
      WelcomePhoneCompleted = { backgroundColor: "white", color: "black" };      
      deviceProvidedNeedToShipDevice =  { backgroundColor: "white", color: "black" };      
    } else if (this.state.onDisplayWelcomePhoneNeeded) {
      // Display Requested RPM
      allOnBoarding = { backgroundColor: "white", color: "black" };
      mRequestedRPM =  { backgroundColor: "white", color: "black" };
      mPreShipment = { backgroundColor: "white", color: "black" };
      mNeedToShipDevice = { backgroundColor: "white", color: "black" };
      WelcomePhoneNeeded = { backgroundColor: "#198ae3", color: "white" };
      WelcomePhoneCompleted = { backgroundColor: "white", color: "black" };      
      deviceProvidedNeedToShipDevice =  { backgroundColor: "white", color: "black" };      
    } else if (this.state.onDisplayWelcomePhoneCompleted) {
      // Display WelcomePhone Completed
      allOnBoarding = { backgroundColor: "white", color: "black" };
      mRequestedRPM =  { backgroundColor: "white", color: "black" };
      mPreShipment = { backgroundColor: "white", color: "black" };
      mNeedToShipDevice = { backgroundColor: "white", color: "black" };
      WelcomePhoneNeeded = { backgroundColor: "white", color: "black" };
      WelcomePhoneCompleted =  { backgroundColor: "#198ae3", color: "white" };      
      deviceProvidedNeedToShipDevice =  { backgroundColor: "white", color: "black" };      
    }else if(this.state.onDeviceProvidedNeedToShipDevice){
      allOnBoarding = { backgroundColor: "white", color: "black" };
      mRequestedRPM =  { backgroundColor: "white", color: "black" };
      mPreShipment = { backgroundColor: "white", color: "black" };
      mNeedToShipDevice = { backgroundColor: "white", color: "black" };
      WelcomePhoneNeeded = { backgroundColor: "white", color: "black" };
      WelcomePhoneCompleted =  { backgroundColor: "white", color: "black" };      
      deviceProvidedNeedToShipDevice =  { backgroundColor: "#198ae3", color: "white" };      
    }
    const device = getDeviceType();
    return (
      <div>
        <div className="row">
          <div className="col-12 grid-margin">          
            <div className="card">
              <div className="card-body project-tab pt-2">
                <Nav tabs className="justify-content-center">
                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: this.state.activeTab === "1"
                      })}
                      onClick={() => {
                        this.toggle("1");
                      }}
                    >
                      <img className="img-tabsfluid" src={onBoarding} style={{marginRight:5}}/>
                      RPM On-Boarding
                    </NavLink>
                  </NavItem>
                </Nav>
                <Row>
                  <Col sm="12" className="grid-margin mt-4 remove-pading-table">
                    {!this.state.loading && (
                      <ReactLoading className="mx-auto" color={"#007bff"} />
                    )}
                    {this.state.loading && (
                      <Row style={{marginLeft : '7px', marginRight : '7px'}}>
                        <Col xs={12} sm={6} md={4} lg={device === deviceType.tablet ? 4 : 2} className="mb-1" style={{paddingLeft: '4px', paddingRight: '4px'}}>
                          <div
                            className="card overflow-hidden"
                            style={{ cursor: "pointer", wordWrap: 'break-word' }}
                            onClick={() =>
                              this.onDisplayAll()
                            }
                          >
                            <SelectationTab
                              title={"All Patients"}
                              displayCount={allOnBoardingSize}
                              style={allOnBoarding}
                            />
                          </div>
                        </Col>
                        <Col xs={12} sm={6} md={4} lg={device === deviceType.tablet ? 4 : 2} className="mb-1" style={{paddingLeft: '4px', paddingRight: '4px'}}>
                          <div
                            className="card overflow-hidden"
                            style={{ cursor: "pointer", wordWrap: 'break-word' }}
                            onClick={() =>
                              this.onDisplayRequestedRPM()
                            }
                          >
                            <SelectationTab
                              title={"Requested Order from Provider"}
                              displayCount={requestedRPMOrderFromProviderSize}
                              style={mRequestedRPM}
                            />
                          </div>
                        </Col>
                        <Col xs={12} sm={6} md={4} lg={device === deviceType.tablet ? 4 : 2} className="mb-1" style={{paddingLeft: '4px', paddingRight: '4px'}}>
                          <div
                            className="card overflow-hidden"
                            style={{ cursor: "pointer", wordWrap: 'break-word' }}
                            onClick={() =>
                              this.onDisplayPreShipment()
                            }
                          >
                            <SelectationTab
                              title={"Pre-Shipment Phone Call Needed"}
                              displayCount={preShipmentPhoneCallSize}
                              style={mPreShipment}
                            />
                          </div>
                        </Col>
                        <Col xs={12} sm={6} md={4} lg={device === deviceType.tablet ? 4 : 2} className="mb-1" style={{paddingLeft: '4px', paddingRight: '4px'}}>
                          <div
                            className="card overflow-hidden"
                            style={{ cursor: "pointer", wordWrap: 'break-word' }}
                            onClick={() =>
                              this.onDeviceProvidedNeedToShipDevice()
                            }
                          >
                            <SelectationTab
                              title={"Device Provided / Need to Ship"}
                              displayCount={deviceProvidedNeedToShipDeviceSize}
                              style={deviceProvidedNeedToShipDevice}
                            />
                          </div>
                        </Col>
                        <Col xs={12} sm={6} md={4} lg={device === deviceType.tablet ? 4 : 2} className="mb-1" style={{paddingLeft: '4px', paddingRight: '4px'}}>
                          <div
                            className="card overflow-hidden"
                            style={{ cursor: "pointer", wordWrap: 'break-word' }}
                            onClick={() =>
                              this.onNeedToShipDevice()
                            }
                          >
                            <SelectationTab
                              title={"Need to Ship Device(s)"}
                              displayCount={needToShipDeviceSize}
                              style={mNeedToShipDevice}
                            />
                          </div>
                        </Col>
                        <Col xs={12} sm={6} md={4} lg={device === deviceType.tablet ? 4 : 2} className="mb-1" style={{paddingLeft: '4px', paddingRight: '4px'}}>
                          <div
                            className="card overflow-hidden"
                            style={{ cursor: "pointer", wordWrap: 'break-word' }}
                            onClick={() =>
                              this.onDisplayWelcomePhoneNeeded()
                            }
                          >
                            <SelectationTab
                              title={"Welcome Call / Account Review Needed"}
                              displayCount={welcomePhoneCallNeededSize}
                              style={WelcomePhoneNeeded}
                            />
                          </div>
                        </Col>
                      </Row>
                    )}
                  </Col>
                  <OnBoardingList
                      fetchDataFromServer={click => this.fetchData = click}
                      catagoryID={this.state.catagoryID}
                      profileOwner={this.props.profileOwner}
                      userId={this.props.userId}
                      mDeviceList={this.props.mDeviceList}
                    />
                </Row>                
              </div>
            </div>
          </div>
        </div>       
      </div>
    );
  }
}
const mapStateToProps = ({ careprovider, user, auth }) => {
  const {
    isGenericSuccess,
    isGenericError,
    genericErrorMessage,
    mDeviceList,
    onBoardingDataCount
  } = careprovider;
  const userId = user.userDetails._id;
  const profileOwner = user.profileOwner;
  return {
    isGenericSuccess,
    isGenericError,
    genericErrorMessage,
    mDeviceList,
    onBoardingDataCount,
    userId,
    profileOwner
  };
};

export default connect(mapStateToProps)(OnBoarding);
